'use strict';

var ContributingFBCsGridTransformerFactory = function ContributingFBCsGridTransformerFactory(DataTransformer, momentService) {
  function ContributingFBCsGridTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'fares-mode';
    this.targetType = 'contributing-fbcs';
    this.priority = 1;
  }
  ContributingFBCsGridTransformer.prototype = Object.create(DataTransformer.prototype);
  ContributingFBCsGridTransformer.constructor = ContributingFBCsGridTransformer;
  ContributingFBCsGridTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  ContributingFBCsGridTransformer.prototype.isCacheable = function () {
    return true;
  };
  ContributingFBCsGridTransformer.prototype.getCacheKey = function () {
    return this.sourceType + '-' + this.targetType;
  };
  ContributingFBCsGridTransformer.prototype.transform = function (data) {
    if (data.domain.results) {
      var results = data.domain.results;
      for (var index = 0, dataLength = results.length; index < dataLength; index++) {
        var element = results[index];
        element.market = element.origin + '-' + element.destination;
        element.bookingClass = element.className;
        element.applicableDateRangeBegin = momentService.of(element.applicableDateRangeBegin, momentService.FIELD.APPLICABLE_DATE_RANGE);
        element.applicableDateRangeEnd = momentService.of(element.applicableDateRangeEnd, momentService.FIELD.APPLICABLE_DATE_RANGE);
        element.lastProcessedDateMoment = momentService.of(element.eventTimeStamp, momentService.FIELD.EVENT_TIME_STAMP);
        if (element.userFare === null) {
          delete element.userFare;
        }
        if (element.userTraffic === null) {
          delete element.userTraffic;
        }
        if (element.nbrOfObs === null) {
          delete element.nbrOfObs;
        }
        if (element.roundTripIndicator === null) {
          delete element.roundTripIndicator;
        }
        if (element.roundTripIndicator === true) {
          element.roundTripIndicator = 'RT';
        }
        if (element.roundTripIndicator === false) {
          element.roundTripIndicator = 'OW';
        }
      }
      return results;
    } else {
      return [];
    }
  };
  return ContributingFBCsGridTransformer;
};
ContributingFBCsGridTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = ContributingFBCsGridTransformerFactory;